const state = {
	info: {},
	is_forbid_order:true, // 是否禁止全员下单 false 不禁用。true 禁用 非紫涵一直都是不禁用
};
const mutations = {
	updateMeetingDetailDate (state, status) {
		state.info = status || {};
	},
	updatIsForbidOrder (state, payload) {
		state.is_forbid_order = payload;
	},
};
export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/storage/vuex/module/meetingDetail.js